<template v-if="loading">
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>
          <!-- 取引先
          <v-spacer></v-spacer>-->
          <v-text-field v-model="search" label="取引先名検索" single-line hide-details></v-text-field>
          <!-- append-icon="search"-->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="suppliers"
          :search="search"
          :custom-sort="customSort"
          hide-actions
        >
          <template v-slot:items="props">
            <tr @click="forwardSupplierEdit(props.item)">
              <td>{{ props.item.supplierCode }}</td>
              <td class="text-xs-left">{{ props.item.supplierName }}</td>
              <td class="text-xs-left">{{ props.item.postalCode }}</td>
              <td class="text-xs-left">{{ props.item.address }}</td>
              <td class="text-xs-left">{{ props.item.buildingName }}</td>
              <td class="text-xs-left">{{ props.item.contactName }}</td>
              <td class="text-xs-left">{{ props.item.contactInformation }}</td>
              <td class="text-xs-left">{{ props.item.contractType }}</td>
              <td class="text-xs-left" v-if="props.item.isDeleted === '0'">有効</td>
              <td class="text-xs-left" v-else>無効</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >検索キーワード["{{ search }}]に該当する取引先名は存在しません。</v-alert>
          </template>
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <!-- 버튼 영역 -->
    <div class="footer-btns">
      <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
        <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
      </v-btn>
      <v-btn block color="success" dark :to="{ name: 'admin/suppliers/new' }">
        <v-icon dark left>create</v-icon>新規登録
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    console.log('created')
    let thisObj = this

    ServerApiCallService.suppliers()
      .then(response => {
        thisObj.suppliers = response.data.suppliers
        // 初期表示時の
        thisObj.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. supplierCode ')
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.supplierCode < b.supplierCode) {
            return -1
          } else if (a.supplierCode > b.supplierCode) {
            return 1
          }
        } else {
          if (a.supplierCode < b.supplierCode) {
            return 1
          } else if (a.supplierCode > b.supplierCode) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    forwardSupplierEdit(supplierInfo) {
      this.$router.push({
        name: 'admin_suppliers_update',
        params: { supplierCode: supplierInfo.supplierCode }
      })
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      search: '',
      headers: [
        { text: '取引先コード', value: 'supplierCode' },
        { text: '取引先名', value: 'supplierName', sortable: false },
        { text: '郵便番号', value: 'postalCode', sortable: false },
        { text: '住所', value: 'address', sortable: false },
        { text: 'ビル名', value: 'buildingName', sortable: false },
        { text: '担当者', value: 'contactName', sortable: false },
        { text: '連絡先', value: 'contactInformation', sortable: false },
        { text: '契約条件', value: 'contractType', sortable: false },
        { text: 'ステータス', value: 'isDeleted', sortable: false }
      ],
      suppliers: []
    }
  }
}
</script>

<style>
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
